import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {TestResult}from './test-result';

@Injectable({
  providedIn: 'root'
})
export class TestResultService {

  constructor(private http: HttpClient) { }
  GetTestResult() {
    return this.http.get<any>(`${environment.apiUrl}api/TestResult/GetTestResult`);
  }
  GetTestResultById(Id:number) {
    return this.http.get<any>(`${environment.apiUrl}api/TestResult/GetTestResultById?CheckTestId=` + Id);
  }
  
}
